import api from '@/api'


export default {
    website_loaded(state, website) {
        state.website = website;
    },
    stripe_pk_loaded(state, key) {
        state.stripe_pk = key;
    },
    user_loaded(state, user) {
        state.user = user
        if (state.user.accepted_terms == 0) {
            state.show_terms = true;
        }
    },
    set_token(state, token) {
        state.token = token
        api.defaults.headers.common['Authorization'] = token;
        localStorage.setItem('token', token);
    },
    set_continue(state, to) {
        state.continue = to
    },
    logout(state) {
        state.token = null;
        state.user = null;
        state.show_terms = false;
        localStorage.removeItem('token')
        delete api.defaults.headers.common['Authorization']
        try {
            //console.log("FB logout!")
            window.FB.logout()
        } catch (ex) {
            //console.log("Facebook wasnt logged in", ex)
        }
    },
    notifications_loaded(state, data) {
        state.notifications = state.notifications.concat(data)
    },
    notifications_seen(state) {
        state.notifications.forEach(n => {
            n.seen = Date.now()
        })
    },
    notifications_cleared(state) {
        state.notifications = []
    },
    accepted_terms(state) {
        state.user.accepted_terms = 1;
        state.show_terms = false;
    },
    counted_portals(state, count) {
        state.portal_count = count;
    },
    loaded_billing(state, url) {

        window.location.href = url;
        /*
        if (state.billing_window == null || state.billing_window.closed) {
            try {
                state.billing_window = window.open();
                setTimeout(function () {
                    state.billing_window.location = url;
                }, 200)
            } catch (ex) {
                window.location.href = url
            }
        } else {
            state.billing_window.focus()
        }
        */
    },
    applicant_upload_started(state, upload) {
        state.applicant_uploads.push(upload);
    },
    applicant_upload_ended(state, upload) {
        state.applicant_uploads = state.applicant_uploads.filter(u => {
            return u !== upload
        })
    }
}